import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import {
  deletePage,
  createPage,
  changePage,
  savePage,
  showEye,
} from "../core/redux/api/pages";

import GKEvent from "../events";

import PageDialog from "./PageDialog";
import RemovePageDialog from "./RemoveDialog";

import List from "./List";
import Icon from "./Icons";
import { ajaxUri } from "../consts/index";
import { l, copyToPage } from "../functions";
import PageTemplates from "./PageTemplates";
import {
  updatePayloadHistory,
  setHistorying,
} from "../core/redux/api/payloads";

const mapStateToProps = (state) => {
  return {
    fetchedPages: state.rootReducer.fetchedPages || [],
    currentPage: state.rootReducer.currentPage || "home",
    toCopy: state.rootReducer.toCopy || null,
    currentLang: state.rootReducer.currentLang || 1,
  };
};

class PagesList extends Component {
  constructor(props) {
    super(props);

    this.defaultState = {
      pageDatas: null,
      newPage: false,
      unsaved: false,
      removingPage: null,
      currentPage: null,
      importingTemplate: null,
    };

    this.state = this.defaultState;
  }

  _cleanPage = () => {
    this.setState(this.defaultState);
  };

  _changedValue = (key, value) => {
    this.setState(
      {
        ...this.state,
        pageDatas: {
          ...this.state.pageDatas,
          [key]: value,
        },
      },
      () => {
        this.setState({ unsaved: true });
      }
    );
  };

  _editPage = (page) => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "getPageSettings",
        pageid: page.key,
      },
    })
      .then((result) => {
        if (result.data.status === "success")
          this.setState({
            pageDatas: result.data.datas,
            currentPage: page,
            pageType: page.type,
          });
        else GKEvent.notification(result.data.status, result.data.message);
      })
      .catch((error) => {
        GKEvent.notification(
          "error",
          l("Error while loading the page settings. Please try again.")
        );
      });
  };

  _deletePage = () => {
    this.props.deletePage(this.state.removingPage, () => {
      this.setState({ removingPage: null });
    });
  };

  _newPage = () => {
    this.setState({
      newPage: true,
      pageType: "cms",
    });
  };

  _saveSettings = (globalSettings) => {
    if (
      this.state?.pageDatas &&
      [
        "terms-and-conditions",
        "privacy-policy",
        "shipping-policy",
        "refund-policy",
      ].includes(
        this.state?.pageDatas["link_rewrite_" + this.props.currentLang]
      )
    ) {
      return;
    }
    if (
      globalSettings?.previous_order_id > globalSettings?.EZCONF_NEW_ORDER_ID
    ) {
      return;
    }
    if (this.state.pageDatas) {
      GKEvent.updatePageSetting(this.state.pageDatas.background);
      this.props.createPage(
        this.state.pageDatas,
        (this.state.currentPage && this.state.currentPage.key) || null,
        () => {
          this.setState(this.defaultState);
        }
      );
    }
    if (globalSettings) {
      for (const setting in globalSettings) {
        if (["error", "previous_order_id"].includes(setting)) {
          continue;
        }
        this._setGlobalSetting(setting, globalSettings[setting]);
      }
    }
  };

  _setGlobalSetting = (key, value) => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "setSetting",
        key: key,
        value: value,
      },
    })
      .then((result) => {})
      .catch((error) => {
        GKEvent.notification("error", l("Error."));
      });
  };

  _saveLayout = (datas) => {
    this.props.setHistorying(true);
    this.props.updatePayloadHistory(JSON.parse(datas.payload));
    this.props.savePage(false);
  };

  render() {
    return (
      <div className={`pages-list ${this.props.toCopy ? "copy-list" : ""}`}>
        {(this.state.currentPage || this.state.newPage) && (
          <PageDialog
            unsaved={this.state.unsaved}
            currentPage={this.state.currentPage}
            newPage={this.state.newPage}
            pageDatas={this.state.pageDatas}
            pageType={this.state.pageType}
            onSubmit={(globalSettings) => this._saveSettings(globalSettings)}
            onChange={this._changedValue}
            onClose={this._cleanPage}
          />
        )}

        {this.state.importingTemplate && (
          <PageTemplates
            target={this.state.importingTemplate}
            targetId={this.state.importingTemplate}
            onSubmit={(datas, cb = () => {}) => {
              this._saveLayout(datas);
              cb();
            }}
            onClose={this._cleanPage}
          />
        )}

        <RemovePageDialog
          open={this.state.removingPage}
          onConfirm={this._deletePage}
          onClose={this._cleanPage}
          title={l("You are deleting a CMS Page ?")}
        />
        {this.props.toCopy === null && (
          <button className="new-item" onClick={this._newPage}>
            <Icon icon="plus" />
          </button>
        )}
        {this.props.fetchedPages.map((page, index) => {
          let actions = [];

          // if (page.settings)
          //   actions.push({
          //     label: l("Edit settings"),
          //     action: () => {
          //       this._editPage(page);
          //     },
          //   });

          if (page.deletable)
            actions.push({
              label: l("Delete page"),
              action: () => {
                this.setState({ removingPage: page.key });
              },
            });

          // if (this.props.currentPage === page.key && page.layouts)
          //   actions.push({
          //     label: l("Use template"),
          //     action: () => {
          //       this.setState({ importingTemplate: page.layouts });
          //     },
          //   });

          if (page.url) {
            actions.push({
              label: "Preview",
              action: () => {
                window.open(page.url, "_blank");
              },
            });
          }

          if (page.tab === "pages")
            return (
              <List
                key={index}
                active={this.props.currentPage === page.key}
                draggable={false}
                content={[l(page.name)]}
                actions={actions}
                onClick={() => {
                  if (page.url) {
                    this.props.showEye(page.url);
                  } else {
                    this.props.showEye();
                  }
                  if (page.isLayouts) this.props.goToLayout(page.key);
                  else {
                    if (this.props.toCopy)
                      copyToPage(page.key, this.props.toCopy);
                    else this.props.changePage(page.key);
                  }
                }}
                warning={page.missing_element ? l("Missing elements !") : ""}
                readOnly={this.props.toCopy ? true : false}
              />
            );
        })}
      </div>
    );
  }
}

export default connect(mapStateToProps, {
  deletePage,
  createPage,
  changePage,
  updatePayloadHistory,
  setHistorying,
  savePage,
  showEye,
})(PagesList);
